export function getHeader(category) {
  const originHeaders = [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      width: '5%'
    },
    {
      text: 'Tên giáo viên',
      value: 'name',
      width: '35%'
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      width: '15%'
    },
    {
      text: 'Giới tính',
      value: 'gender',
      width: '15%'
    },
    {
      text: 'Trạng thái',
      value: 'status',
      width: '10%'
    }
  ]
  if (category === 'custom') {
    originHeaders.push({
      text: 'Thao tác',
      value: 'action',
      align: 'center',
      width: '10%'
    })
  }
  return originHeaders
}

export function getGroupHeadHeaders(category) {
  if (category === 'main') {
    return [
      { text: 'Thành phần lương', value: 'title', width: '50%' },
      { text: 'Ghi chú', value: 'note', width: '30%' }
    ]
  }
  return [
    { text: 'Điều chỉnh lương', value: 'title', width: '50%' },
    { text: 'Áp dụng với khoản thành phần', value: 'salary_head_apply.title', width: '20%' },
    { text: 'Ghi chú', value: 'note', width: '30%' }
  ]
}

export const schema = {
  'Tên giáo viên': {
    prop: 'name',
    type: String
  },
  'Mã số': {
    prop: 'code',
    type: String
  },
  'Ngày sinh': {
    prop: 'dob',
    type: String
  },
  'Giới tính': {
    prop: 'gender',
    type: String
  },
  'Trạng thái': {
    prop: 'status',
    type: String
  }
}

export const importSampleHeaders = [
  { text: 'Tên giáo viên', value: 'name' },
  { text: 'Mã số', value: 'code' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Giới tính', value: 'gender' },
  { text: 'Trạng thái', value: 'status' }
]

export const importSampleData = [
  { name: 'Nguyễn Hồng Nhung', code: 'nhungnh', dob: '27/04/2011', gender: 'Nữ', status: 'Đang dạy' }
]
